module.exports = __webpack_public_path__ + "static/media/Asset2.4db8428e.png";